import React from 'react';

class Header extends React.Component {
  render() {
    return (
      <div className="on-track-header">
        <h1 className="on-track-header-one">Course Credits</h1>
      </div>
    );
  }
}

export default Header;
